import * as FileSystemService from '../../../services/file/fileSystemService';

/**
 * Sets a classroom as archived by updating its state to '0'
 * @param classId
 * @param userId
 * @returns {function(*, *)}
 */
export let archiveClassroomPostAction = (classId, userId) => {
  return dispatch => {
    FileSystemService.removeClassroomContent(classId, userId);
  };
};
